import { render, staticRenderFns } from "./UserMembersTable.vue?vue&type=template&id=18c3d80e&scoped=true&"
import script from "./UserMembersTable.vue?vue&type=script&lang=js&"
export * from "./UserMembersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3d80e",
  null
  
)

export default component.exports